import hyperdom from 'hyperdom'
import responsiveRender from '../../../responsiveRender.js'
import placeholderPolyfill from '../../../placeholderPolyfill.jsx'
import SectionComponentBase from './sectionComponentBase.jsx'
import SpecialRequirementsSchema from './specialRequirementsSchema.js'

export default class SpecialRequirements extends SectionComponentBase {
  constructor ({browserCapabilities, config, quoteCriteria}) {
    super({sectionName: 'special-requirements'})
    this.browserCapabilities = browserCapabilities
    this.config = config
    this.quoteCriteria = quoteCriteria
    this.schema = new SpecialRequirementsSchema({config: this.config}).buildSchema()
  }

  render () {
    return <div className='special-requirements'>
      <div className='o-accent-box u-margin-bottom-medium'>
        <p className='special-requirements__title'>Do any of the passengers have any special requests?</p>
        {responsiveRender('small',
          () => this.renderMobile(),
          () => this.renderDesktop()
        )}
      </div>
    </div>
  }

  renderMobile () {
    return [
      this.renderRadioButtons({
        onNoClick: () => this.quoteCriteria.passengers.forEach(p => delete p.specialRequirements),
      }),
      this.toggledForMobile ? this.renderPassengersList() : undefined,
    ]
  }

  renderDesktop () {
    return this.renderPassengersList()
  }

  renderPassengersList () {
    return <div className='special-requirements__passengers'>
      {this.quoteCriteria.passengers.map((passenger,index) => {
        return <div className={`special-requirements__passenger`}>
          <label className='o-choice-item -fullWidth'>
            <input type='checkbox' className='o-choice-item__checkbox'
              binding={[passenger, 'specialRequirements']}/>
            <div className='o-choice-item__content'>
              <span className={index === 0 ? 'passenger-name-semibold' : 'passenger-name'}>
                {passenger.fullName()}{index === 0 ? ` (Lead Passenger)` : ``}
              </span>
            </div>
          </label>
          <div className={["question-container", {'show-expanded': passenger.specialRequirements}]}>
            {placeholderPolyfill(
              <textarea
                id={`pax-special-requests-${index}`}
                binding={[passenger, 'specialRequests']}
                placeholder='e.g. food or medical requirements, accommodation preferences, special occasions'
                name='specialRequests'
                onblur={() => {
                  this.fieldVisited(passenger, 'specialRequests', `pax-special-requests-${index}`)
                  this.isFieldInvalid(passenger, 'specialRequests')
                }}/>,
              this.browserCapabilities
            )}
            {this.renderValidationError(passenger, 'specialRequests')}
          </div>
        </div>
      })}
    </div>
  }
}
